import React from 'react'
import { FormattedMessage } from 'react-intl'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { EmailDomainsForm } from './email-domains-form'
import { EmailDomainsQuery } from './email-domains-query'

export function EmailDomainsSecuritySection({ organizationID }) {
  return (
    <EmailDomainsQuery organizationID={organizationID}>
      {({ domains }) => (
        <div className="panel panel-default">
          <div className="panel-heading">
            <FormattedMessage
              id="title_emailDomains"
              children={(msg) => (
                <span className="panel-heading-title">{msg}</span>
              )}
            />
          </div>
          <div className="panel-body">
            <FormattedMessage
              id="detail_securitySettingsEmailDomains_description"
              children={(msg) => (
                <span
                  className={css`
                    color: ${theme.color.neutral60};
                  `}
                >
                  {msg}
                </span>
              )}
            />
            <EmailDomainsForm
              organizationID={organizationID}
              emailDomains={domains ? domains.join(',') : ''}
            />
          </div>
        </div>
      )}
    </EmailDomainsQuery>
  )
}
